import { AvatarUploader } from "../common-forms/AvatarUploader";
import {
  Text,
  Box,
  Button,
  useToast,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Spinner,
  IconButton,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Modal,
  ModalOverlay,
  useDisclosure,
} from "@chakra-ui/react";

import Image from "next/legacy/image";
import { IconAlertCircle, IconDelete } from "../../../../../styles/icons";
import {
  profileAccordionButton,
  profileAccordionPanel,
} from "../../../../utilities/render-helpers/renderPractitionerProfile";
import { useSelector, useDispatch } from "react-redux";
import { useState } from "react";
import { patchData, postData } from "../../../../utilities/axios";
import { updateUserDetails } from "../../../../redux/actions/user";
import * as N from "../../../../utilities/notifications";
import axios from "axios";

const EditSectionProfileBanner = ({ profile }) => {
  const token = useSelector((state) => state.user.JWTToken);
  const { profileHeaderImage } = profile;

  const [headerImage, setHeaderImage] = useState(profile.profileHeaderImage);
  const [newHeaderImage, setNewHeaderImage] = useState(null);
  const [headerImageSubmitting, setHeaderImageSubmitting] = useState(false);
  const dispatch = useDispatch();
  const toast = useToast();

  const {
    isOpen: deleteOpen,
    onClose: closeDelete,
    onOpen: openDelete,
  } = useDisclosure();

  const saveNewHeaderImage = async () => {
    setHeaderImageSubmitting(true);
    try {
      if (headerImage === profileHeaderImage) {
        return;
      }

      const response = await postData(
        token,
        {
          type: "header",
          contentType: "image/webp",
        },
        `${process.env.NEXT_PUBLIC_NEW_USER_URL}profile/media`,
        process.env.NEXT_PUBLIC_NEW_USER_APIKEY
      );

      const base64Data = Buffer.from(
        headerImage.replace(/^data:image\/\w+;base64,/, ""),
        "base64"
      );

      await axios.put(response.s3PutDetails.url, base64Data, {
        headers: {
          ...response.s3PutDetails.headers,
          "Access-Control-Allow-Origin": "*",
          "Content-Encoding": "base64",
        },
      });
      setNewHeaderImage(response.publicUrl);

      const userUpdateProfile = {
        profileId: profile.profileId,
        practitionerType: "therapist",
        profileHeaderImage: response.publicUrl,
      };

      await patchData(
        token,
        userUpdateProfile,
        `${process.env.NEXT_PUBLIC_NEW_USER_URL}profile`
      );

      await dispatch(
        updateUserDetails({
          therapistProfile: {
            ...profile,
            ...userUpdateProfile,
          },
        })
      );

      toast(N.updateDetailsSuccess);
      setHeaderImageSubmitting(false);
    } catch (error) {
      console.error("PROBLEM SAVING NEW AVATAR", error);
      toast(N.updateDetailsFail(error));
      setHeaderImageSubmitting(false);
    }
  };

  const deleteHeaderImage = async () => {
    setHeaderImageSubmitting(true);
    try {
      setNewHeaderImage(null);
      setHeaderImage(null);

      const userUpdateProfile = {
        profileId: profile.profileId,
        practitionerType: "therapist",
        profileHeaderImage: null,
      };

      await patchData(
        token,
        userUpdateProfile,
        `${process.env.NEXT_PUBLIC_NEW_USER_URL}profile`
      );

      await dispatch(
        updateUserDetails({
          therapistProfile: {
            ...profile,
            ...userUpdateProfile,
          },
        })
      );

      toast(N.updateDetailsSuccess);
      setHeaderImageSubmitting(false);
      closeDelete();
    } catch (error) {
      console.error("PROBLEM SAVING NEW AVATAR", error);
      toast(N.updateDetailsFail(error));
      setHeaderImageSubmitting(false);
    }
  };

  // Render
  return (
    <AccordionItem>
      <Modal isOpen={deleteOpen} onClose={closeDelete} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Delete header image?</ModalHeader>
          <ModalCloseButton />
          <ModalBody className="flex flex-col gap-4">
            <p>Are you sure you wish to continue?</p>
          </ModalBody>

          <ModalFooter justifyContent="space-between" display="flex">
            <Button
              className="text-brand"
              onClick={() => {
                closeDelete();
              }}
            >
              Go back
            </Button>
            <Button
              className="bg-red-500 hover:bg-red-400 rounded-full px-4 py-2 text-white font-bold transition"
              onClick={deleteHeaderImage}
            >
              Delete
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <h2>
        <AccordionButton _expanded={profileAccordionButton}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            flex="1"
            textAlign="left"
          >
            <Box display="flex" alignItems="center">
              <Text>Profile banner</Text>
              <Box
                width="140px"
                height="34px"
                overflow="hidden"
                position="relative"
                margin="16px"
              >
                {!newHeaderImage && !profileHeaderImage ? (
                  <div className="w-full h-full bg-brand" />
                ) : (
                  <Image
                    layout="fill"
                    alt="practitioner photo"
                    objectFit="cover"
                    objectPosition="center"
                    src={newHeaderImage ?? profileHeaderImage}
                    placeholder="blur"
                    unoptimized
                    blurDataURL="data:image/jpeg;base64,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"
                  />
                )}
              </Box>
            </Box>
            {profileHeaderImage !== null && profileHeaderImage !== {} ? (
              <Text padding="8px" textStyle="body2" color="green">
                Complete
              </Text>
            ) : (
              <Box display="flex" alignItems="center" padding="8px">
                <IconAlertCircle size="20px" color="tomato" />
                <Text textStyle="body2" paddingLeft="8px">
                  Adding a background image helps you stand out
                </Text>
              </Box>
            )}
          </Box>
          <AccordionIcon />
        </AccordionButton>
      </h2>
      <AccordionPanel sx={profileAccordionPanel}>
        <div className="flex flex-col rounded items-start gap-6 w-full bg-white p-4">
          <div className="w-full">
            <AvatarUploader
              initialImage={headerImage}
              editorWidth={700}
              editorHeight={170}
              editorRadius={0}
              handleImageChange={setHeaderImage}
            />
            {headerImage && (
              <div className="flex items-center justify-center w-full p-2">
                <Button
                  disabled={headerImageSubmitting}
                  onClick={
                    headerImageSubmitting ? () => {} : saveNewHeaderImage
                  }
                  className="rounded-full flex items-center bg-[#587500] text-white opacity-1 transition px-4 py-2  hover:opacity-[0.7] cursor-pointer data-[disabled]:cursor-not-allowed data-[disabled]:opacity-[0.7]"
                >
                  {headerImageSubmitting ? (
                    <>
                      <Spinner color="white" size="sm" className="mr-3" />
                      Saving...
                    </>
                  ) : (
                    "Save and upload"
                  )}
                </Button>
                <Button
                  disabled={headerImageSubmitting}
                  onClick={headerImageSubmitting ? () => {} : openDelete}
                  className="rounded-full flex items-center bg-[#587500] text-white opacity-1 transition px-4 py-2  hover:opacity-[0.7] cursor-pointer data-[disabled]:cursor-not-allowed data-[disabled]:opacity-[0.7]"
                >
                  Delete Banner Image
                </Button>
              </div>
            )}
          </div>
        </div>
      </AccordionPanel>
    </AccordionItem>
  );
};

export default EditSectionProfileBanner;
